module.exports = __webpack_public_path__ + "img/left.f892e256.png";